export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "left",
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} reveal`}
    >
      {eyebrow ? (
        <div
          className={`text-[11px] tracking-[0.24em] uppercase text-[#8B6DFF] mb-4 ${
            align === "center" ? "" : ""
          }`}
        >
          {eyebrow}
        </div>
      ) : null}
      <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white leading-[1.05]">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-4 text-[15.5px] md:text-[16.5px] text-[#A8A8B3] leading-relaxed">
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
